import script from "./Sensitive.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sensitive.vue?vue&type=script&setup=true&lang=ts"

import "./Sensitive.vue?vue&type=style&index=0&id=da51a7e2&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da51a7e2"]])

export default __exports__